/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable, Optional} from '@angular/core';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {Observable, of} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface ExternalAdUnitModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class ExternalAdUnitApiService extends SignalAdminResourceApiBase<ExternalAdUnitModel> {
  constructor(client: AdnApiClientService, @Optional() localUserProfile?: LocalUserProfile) {
    super(client, 'externaladunits', {}, () => localUserProfile?.isReadOnly() || false);
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<ExternalAdUnitModel>> {
    return this.client.request<SignalAdminResourcePage<ExternalAdUnitModel>>({
      method: 'GET',
      url: this.resourceUri('externaladunits'),
      params
    });
  }

  getMany(ids: string[]): Observable<SignalAdminResourcePage<ExternalAdUnitModel>> {
    if (!ids.length) {
      return of({results: [], totalCount: 0, page: 0});
    }
    return this.listOptions({ids, includeHidden: true, includeInactive: true});
  }
}
